'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const React = require('react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_display_Icon_compiled_index = require('../../../index-BfaQX_sY.js');
const theme_Animation = require('../../../theme/Animation.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');
const components_display_Icon_compiled_MiscAi = require('./compiled/MiscAi.cjs.js');
const components_display_Icon_compiled_MiscAiFill = require('./compiled/MiscAiFill.cjs.js');
const components_display_Icon_compiled_NavAiChatbot = require('./compiled/NavAiChatbot.cjs.js');
const components_display_Icon_compiled_MiscEvergreenAi = require('./compiled/MiscEvergreenAi.cjs.js');

const sanitizeClassName = (size) => {
  return `${size}`.replace(/[^a-z0-9]/gi, "-");
};
const Styles = styleEncapsulation.labelStyles("Icon", {
  root: (props) => [
    Object.assign(Object.assign({}, styleMixins_reset.boxSizing), { label: `-${props.name}`, display: "inline-block", fill: "currentColor", "> svg": {
      display: "block",
      height: "inherit",
      width: "inherit"
    }, "*": {
      fill: "inherit"
    } }),
    // Though this component doesn't manage active state on its own such that
    // transition styles are necessary, its parent might. When a parent is
    // toggling this component's `color` prop, we need to animate that
    // consistently with our other transitions.
    props.shouldAnimateFill && styleEncapsulation.withModifier("animate", {
      transitionProperty: "fill",
      transitionTimingFunction: theme_Animation.Animation.transitionTimingFunction,
      transitionDuration: theme_Animation.Animation.transitionDuration
    }),
    !props.canAcceptPointerEvents && styleEncapsulation.withModifier("disable-pointer-events", {
      pointerEvents: "none"
    }),
    props.isBlock && styleEncapsulation.withModifier("block", {
      display: "block"
    }),
    styleEncapsulation.withModifier(sanitizeClassName(`${props.size}x${props.size}`), {
      height: props.size,
      width: props.size
    }),
    props.color && styleEncapsulation.withModifier(props.color, {
      fill: theme_Colors.Colors[props.color]
    })
  ]
});
const MissingIcon = () => react.jsx(
  "svg",
  { "aria-label": "Could not load icon", "data-is-missing-icon": "true", viewBox: "0 0 24 24" },
  react.jsx("rect", { height: "24", width: "24", x: "0", y: "0" })
);
class IconErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      didFailToLoad: false
    };
  }
  static getDerivedStateFromError() {
    return {
      didFailToLoad: true
    };
  }
  render() {
    return this.state.didFailToLoad ? react.jsx(MissingIcon, null) : this.props.children;
  }
}
const Icon = ({ "aria-label": ariaLabel, color, isBlock, name, "aria-hidden": ariaHidden = true, canAcceptPointerEvents = true, shouldAnimateFill = true, size = "small" }) => {
  const IconComponent = getIcon(name);
  let cssSize = size;
  switch (size) {
    case "small":
      cssSize = "24px";
      break;
    case "medium":
      cssSize = "36px";
      break;
    case "large":
      cssSize = "48px";
      break;
  }
  const stylesOptions = {
    name,
    canAcceptPointerEvents,
    isBlock,
    color,
    shouldAnimateFill,
    size: cssSize
  };
  return react.jsx(
    "span",
    { "aria-hidden": ariaHidden ? "true" : void 0, "aria-label": ariaLabel, css: Styles.root(stylesOptions), "data-testid": "iconContainer", "data-zds": true },
    react.jsx(
      IconErrorBoundary,
      null,
      react.jsx(IconComponent, { size: cssSize, color, name })
    )
  );
};
function getIcon(name) {
  try {
    if (name === "miscAI") {
      return components_display_Icon_compiled_MiscAi;
    }
    if (name === "miscAIFill") {
      return components_display_Icon_compiled_MiscAiFill;
    }
    if (name === "navAIChatbot") {
      return components_display_Icon_compiled_NavAiChatbot;
    }
    if (name === "miscEvergreenAI") {
      return components_display_Icon_compiled_MiscEvergreenAi;
    }
    const capitalizedIcon = `${name[0].toUpperCase()}${name.substring(1)}`;
    return components_display_Icon_compiled_index.Icons[capitalizedIcon] || MissingIcon;
  } catch (_a) {
    return MissingIcon;
  }
}

exports.Icon = Icon;
//# sourceMappingURL=Icon.cjs.js.map
